import { F0Button } from '@factorialco/f0-react'

import Callout from 'modules/core/components/Callout'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

interface ConfirmationModalProps {
  onClose: () => void
  onSubmit: () => void
}

export function ConfirmationModal({ onClose, onSubmit }: ConfirmationModalProps) {
  const { syncFilterParameters } = useIntegrationsSyncContext()

  const hasFiltersApplied = syncFilterParameters.length > 0

  return (
    <Modal
      title={i18n.t('compensations.integrations.sync_confirmation_modal.title')}
      description={i18n.t('compensations.integrations.sync_confirmation_modal.description')}
      illustration="sync"
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <F0Button
            onClick={onClose}
            variant="outline"
            label={i18n.t('compensations.integrations.sync_confirmation_modal.cancel_cta')}
          />
          <F0Button
            variant="default"
            label={i18n.t('compensations.integrations.sync_confirmation_modal.sync_cta')}
          />
        </>
      }
    >
      {hasFiltersApplied && (
        <Callout
          type="warning"
          title={i18n.t('compensations.integrations.sync_confirmation_modal.filters_callout.title')}
          description={i18n.t(
            'compensations.integrations.sync_confirmation_modal.filters_callout.description'
          )}
        />
      )}
    </Modal>
  )
}
